import React, { useEffect } from 'react'
import { PageContentLayout } from '@components'
import { CalendarSidebar, CalendarView } from '@modules/calendar'
import { ConfigPageProvider } from '@context/ConfigPageContext'
import { useConfigurationMode } from '@context/ConfigurationContext'

const CalendarPage: React.FC = () => {
  const { enableConfigurationModeToggle, disableConfigurationModeToggle } =
    useConfigurationMode()

  useEffect(() => {
    disableConfigurationModeToggle()
    return () => {
      enableConfigurationModeToggle()
    }
  }, [])

  return (
    <ConfigPageProvider>
      <PageContentLayout>
        <CalendarSidebar />
        <CalendarView />
      </PageContentLayout>
    </ConfigPageProvider>
  )
}
export default CalendarPage
